webpackJsonp([5],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(19);


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	
	$(function () {
	    $('#filters form').on('change', function() {
	        $(this).submit();
	    });
	});


/***/ })

});


// WEBPACK FOOTER //
// site/legends_picks.dc36230ee3d782dad770.js